export const GET_FUND_ACTIONS = {
    GET_FUND_STARTED: 'GET_FUND_STARTED',
    GET_FUND_OK: 'GET_FUND_OK',
    GET_FUND_ERROR: 'GET_FUND_ERROR',
    GET_FUND_INVALID_RESPONSE: 'GET_FUND_INVALID_RESPONSE',
    GET_FUND_INVALID_JSON: 'GET_FUND_INVALID_JSON',
}
